export default __webpack_public_path__ + "static/media/cherry.27b65f07.jpg";